export default {
  projectName: 'QNAP Switch System',
  qssprojectName: 'QSS Management',
  yes: 'Yes',
  up: 'Online',
  down: 'Offline',
  all: 'All',
  ok: 'OK',
  cancel: 'Cancel',
  save: 'Save',
  add: 'Add',
  action: 'Action',
  search: 'Search',
  clear: 'Clear',
  edit: 'Edit',
  delete: 'Delete',
  group: 'Group',
  received: 'Received',
  transmitted: 'Sent',
  empty: 'No data to display.',
  noResult: 'No results',
  update: 'Update',
  smallPort: 'port',
  warning: 'Warning',
  linkUp: 'Link up',
  linkDown: 'Link down',
  tenGlink: '10GbE Enabled',
  config: 'Configuration',
  minAgo: '3 mins ago',
  now: 'Now',
  restart: 'Restart',
  mbps: 'Mbps',
  rule: 'Permission',
  today: 'Today',
  selected: 'Selected',
  loading: 'Loading...',
  updating: 'Firmware is updating, please wait…',
  uploading: 'File is uploading, please wait…',
  interfaceTitle: 'Interface Settings:',
  lagTitle: 'LAG Settings:',
  header: {
    logout: 'Log out',
    // help: 'Help',
    language: 'Language',
    more: 'More',
    reboot: 'Restart Switch',
    restartMsg: 'Do you want to restart the switch?',
    restartLoad: 'Restarting...',
    restoreLoad: 'Restoring...',
    resetLoad: 'Resetting...',
    autodetect: 'Auto-detect'
  },
  about: {
    title: 'About',
    version: 'Version',
    copyright: '©{0} QNAP Systems, Inc. All Rights Reserved.'
  },
  warningWin: {
    title: 'Unsaved settings',
    content: 'Do you want to leave without saving the new settings?',
    timeoutTitle: 'Session Expired',
    timeoutContent: 'Your session has expired. Clicking "OK" will redirect you to the login page.',
    repeatLogin: 'Duplicate login detected. Click "OK" to go back to the login page.',
    busyTitle: 'Login Error',
    busyContent: 'Firmware update in progress. Try again later.'
  },
  errorMessage: {
    isReguired: 'This value is required.',
    alreadyExist: 'This port already belongs to another group.',
    password: 'The password must be 8-20 characters long.',
    vlanIdRange: 'Allowed values: 2-4000',
    staticMacVlanIdRange: 'Allowed values: 1-4000',
    lacpRange: 'The value must be a number between 1-6.',
    macTimeRange: 'This value must be a number between 10 - {0}.',
    format: 'Incorrect Format',
    groupNumDuplicate: 'This group number already exists.',
    vlanNumDuplicate: 'This ID already exists.',
    vlanNumNoExists: 'This VLAN ID does not exist.',
    ipFormat: 'Incorrect IP address format. The IP address must follow the following format: xxx.xxx.xxx.xxx',
    macFormat: 'Incorrect MAC address format. The MAC address must follow the following format: FF:FF:FF:FF:FF:FF',
    aclRange: 'The value must be a number between 1-255.',
    aclIDused: 'The ACL number already exists. Check the ACL number you have entered and try again or abort the action.',
    LAGPortused: 'A selected port is already in another group.',
    hostnameLength: 'The host name must be 1-{0} characters long.',
    hostnameInvaild: 'This field can only contain letters (A-Z, a-z), numbers (0-9), and special characters (-).',
    ipAndSubnetEmpty: 'IP address field is required.',
    dhcpFormat: 'Invalid IP address. A valid IP must follow this format and range: (1-223:0-255:0-255:0-255).',
    subnetFormat: 'Invalid IP address for subnet mask.',
    ipInvalid: 'Invalid IP address.',
    dnserror: 'DNS configuration is incomplete. Configure the DNS settings in the System Settings page.',
    snmperror: 'An unexpected error has occurred. If the problem persists, contact QNAP customer service. (Error code: {0})',
    ntpserverError: 'Server names can only contain letters (A-Z, a-z), numbers (0-9), hyphens (-), underscores (_), and periods (.).',
    ntpsyncError: 'Unable to synchronize with NTP server. Check the NTP server IP address or the network connection.',
    unknownError: 'An unexpected error occurred. If the problem persists, contact the support provider.',
    networkError: 'Unable to connect to the internet. Check your network connection.',
    serverError: 'Unable to connect to the server. Check your network connection.',
    connectFail: 'Unable to connect to the server.',
    existInAcl: 'ACL-enabled ports cannot be selected for LAG port configuration.',
    existInLag: 'LAG-enabled ports cannot be selected for ACL port configuration.',
    restoreSystemError: 'System Error',
    restoreFileError: 'Unable to restore configuration from the backup file. Verify the file integrity.',
    gatewayInvalid: 'The gateway cannot be the same as the IP address.',
    submaskInvalid: 'Enter a valid IP address for specified subnet mask.',
    systemDestroyed: 'The system detected a corrupt firmware file during the reboot process. To avoid abnormal system operations, the switch has downgraded to a previous working version of the firmware.',
    minVersionErr: 'A system error occurred while attempting to update the firmware with an firmware version "{0}" or an earlier version. QSS does not support firmware downgrades as it can impact system stability.',
    snmpNameInvaild: 'This field can only contain letters (A-Z, a-z) and numbers (0-9).',
    snmpPasswordRange: 'The password must be 8-31 characters long.'
  },
  login: {
    title: 'QNAP Switch System (QSS)',
    slogan: 'Welcome to QSS! The switch management system helps you to easily set up and manage your network. Network planning is made easier with step-by-step guidance and a user-friendly interface.',
    username: 'Username:',
    nameText: 'Enter username',
    password: 'Password:',
    passwordText: 'Enter password',
    rememberMe: 'Remember me',
    authorizedError: 'Invalid username or password.',
    loginBtn: 'Log in',
    qswBtnTips: 'Log in to QSS',
    logoutAuto: 'Your login information has changed. The system will automatically log you out in {0} seconds.',
    defaultMsg: 'You cannot use the MAC Address as your password.',
    detectedPwd: 'The system has detected that you have not changed your password. For security reasons, please change your password immediately.',
    IEnonsupport: 'The browser you are using maybe experience compatibility issues. Use Google Chrome, Microsoft Edge, Safari, or Mozilla Firefox for a better experience.'
  },
  menu: {
    dashboard: 'Overview',
    systemMgmt: 'System',
    sysControl: 'System Settings',
    sysinformation: 'System Information',
    syssetting: 'Settings',
    sysdhcp: 'IP',
    syspassword: 'Password',
    systime: 'Time',
    configurations: 'Configuration',
    port: 'Port Management',
    portstatus: 'Port Status',
    portstatistics: 'Port Statistics',
    portconfigure: 'Port Configuration',
    vlan: 'VLAN',
    aggregation: 'Link Aggregation',
    rstp: 'RSTP',
    rstpconfig: 'RSTP Configuration',
    mactable: 'MAC Address Table',
    ratelimit: 'Rate Limits',
    acl: 'ACL',
    aclmac: 'By MAC Address',
    aclip: 'By IP Address',
    igmp: 'IGMP Snooping',
    igmpsnooping: 'IGMP Snooping',
    igmpstatistic: 'IGMP Snooping Statistics',
    qos: 'QoS',
    portmirroring: 'Port Mirroring',
    lldp: 'LLDP',
    lldpconfig: 'LLDP Configuration',
    lldpremote: 'LLDP Remote Devices',
    firmwareupdate: 'Firmware Update',
    liveupdate: 'Live Update',
    howto: 'Setting Guide',
    sysbackup: 'Backup & Restore',
    syshttps: 'HTTPS',
    syssnmp: 'SNMP',
    poe: 'PoE',
    poeSchedule: 'PoE Schedule',
    powerConfiguration: 'Power Configuration',
    powerConsumption: 'Power Consumption'
  },
  deviceinfo: {
    dashboard: 'Dashboard',
    info: 'Device information:',
    portStatus: 'Port Status',
    vlanStatus: 'VLAN Status',
    LAGStatus: 'LAG Status',
    oneGStatus: '1 GbE Port Traffic History',
    tesGStatus: '10 GbE Port Traffic History',
    twoG5Status: '2.5 GbE Port Traffic History',
    twentyG5Status: '25 GbE Port Traffic History',
    portTrafficHistory: '{0} GbE Port Traffic History',
    port: 'Port:',
    porttitle: 'Current Port status:',
    LAGtitle: 'Trunking groups:',
    vlantitle: 'Current VLAN status:',
    poeStatus: 'PoE Status',
    pdStatus: 'Powered Device Status',
    pdtitle: 'Connected PD ports:',
    poetitle: 'Current PoE status:',
    pdClass: 'class {0}',
    none: 'none',
    power: 'Power supply'
  },
  overview: {
    portStatus: 'Port Status',
    vlanStatus: 'VLAN Status',
    LAGStatus: 'LAG Status',
    modelname: 'Model Name:',
    temperature: 'Temperature:',
    switchFw: 'Switch firmware:',
    macaddress: 'MAC address:',
    ipaddress: 'IP address:',
    fanSpeed: 'Fan speed:',
    multifanSpeed: 'Fan {0} speed:',
    portNo: 'Port',
    trafficIn: 'Traffic In',
    trafficOut: 'Traffic Out',
    aggretrunking: 'Trunking groups:',
    tempInfo: 'Optimal operating temperature: 0°C – 125°C (32°F – 257°F)',
    loading: 'Loading...',
    oneGtraffic: 'Port Traffic',
    tenGtraffic: '10GbE Port Traffic',
    twoG5traffic: '2.5GbE Port Traffic',
    twentyG5traffic: '25GbE Port Traffic',
    gbps: 'Gbps',
    currentTraffic: 'Current Traffic:',
    totalTraffic: 'Total Traffic:',
    normal: 'Normal',
    abnormal: 'Abnormal',
    activePower: 'Active PSU:',
    powerTitle: 'PSU {0}:',
    power: 'PSU {0}',
    powerConsumption: 'PoE Power Consumption',
    perPortPower: 'Current Port Power Consumption',
    perPortRate: 'Current Port Traffic',
    total: 'Total:',
    inUse: 'In use:',
    budget: 'Available:',
    circelUsed: 'Used'
  },
  port: {
    describe: 'Port Management allows you to control all the switching ports, configure the maximum speed, and manage the flow control of a port.',
    portnumber: 'Port',
    link: 'Link Status',
    state: 'State',
    speed: 'Speed',
    flowcontrol: 'Flow Control',
    bytes: 'Bytes',
    errors: 'Errors',
    packets: 'Packets',
    mac: 'MAC address',
    type: 'Type',
    name: 'Name',
    enabled: 'Enabled',
    disabled: 'Disabled',
    warningHeader: 'Clear statistics',
    clearInfo: 'Do you want to clear all port statistics?',
    selectType: 'Type:',
    fcsError: 'FCS Errors',
    force10ModeFdx: '10Mbps FDX',
    force10ModeHdx: '10Mbps HDX',
    force100ModeFdx: '100Mbps FDX',
    force100ModeHdx: '100Mbps HDX',
    force1GModeFdx: '1Gbps FDX',
    force10GModeFdx: '10Gbps FDX',
    force2p5GModeFdx: '2.5Gbps FDX',
    force5GModeFdx: '5Gbps FDX',
    autoNegMode: 'Auto',
    fcTips: 'When speed is set to Auto, Flow Control is advertised to the link partner.',
    hdxTips: 'When speed is set to HDX, Flow Control is not supported.',
    speedInfo: 'Applies only to the RJ45 interface speed settings.',
    fecInfo: 'Forward Error Correction (FEC) reduces data transmission error rate across the network. You can disable FEC mode, change to auto-FEC to allow the switch to automatically select the FEC mode, or select BASE-R FEC or RS-FEC modes to support 25 Gbps speeds.',
    fecInfoNote: 'Note: Changing the FEC mode causes a brief interruption in network connection.',
    lagInfo: 'LAG speed is enabled and set to "Auto" by default. You can enable or disable it under the "State" setting.',
    sfpFlowControl: 'Unable to detect the flow control status of the SFP/SFP+/SFP28 port.',
    fecLimit: 'You can enable FEC on up to 14 ports only.',
    fec: 'FEC',
    details: 'Details',
    view: 'View',
    fecTip: '10 Gbps ports do not support FEC modes.',
    speedSfpInfo: 'SFP/SFP+/SFP28 ports support Auto mode only.',
    transceiver: 'Transceiver',
    notSupTransceiver: 'Not supported',
    notSupFec: 'Not supported',
    baseRFec: 'BASE-R-FEC',
    rsFec: 'RS-FEC',
    autoFec: 'Auto-FEC'
  },
  vlan: {
    describe: 'VLAN (Virtual Local Area Network) allows administrators to group different ports on one or multiple connected switches. VLAN tagging keeps traffic from different networks separated when traversing shared links and delivers tagged packets to their corresponding VLAN(s).',
    addVlan: 'Add VLAN',
    vlanId: 'VLAN ID',
    vlanCong: 'Port Configuration:',
    tagged: 'Tag Status',
    editVlan: 'Edit VLAN',
    untag: 'Untagged',
    tag: 'Tagged',
    atleastOne: 'Each port must join at least one VLAN.',
    deleteTitle: 'Delete VLAN',
    deleteContent: 'Do you want to delete this VLAN?',
    ports: 'Ports:',
    addVlanLimit: 'VLAN ID maximum value: 4000',
    boundingNote: 'If you need to add a link aggregation group to VLAN(s), ensure that you add all the bonded ports of the group.',
    empty: 'VLAN {0} cannot be empty.',
    manageEmpty: 'Management VLAN {0} cannot be empty.'
  },
  lag: {
    describe: 'LAG (Link Aggregation Group) combines multiple point-to-point links into a single high throughput data link, for yielding shared traffic load among individual links and enhancing connectivity.',
    trunkingGroup: 'Trunking groups:',
    groupName: 'LAG',
    LACP: 'LACP',
    portMember: 'Port Members',
    action: 'Action',
    addGroup: 'Add Group',
    editGroup: 'Edit Group',
    deleteGroup: 'Are you sure you want to clear the group settings?',
    noGroup: 'No trunking groups have been configured.',
    groupNumber: 'Group Number',
    note: 'Enable link aggregation before connecting cables to the switch to avoid creating a data loop.',
    limit: 'The limit of each group is 4 ports.',
    clear: 'Clear settings',
    groupLimit: 'You can create up to 6 trunking groups.',
    mode: 'Mode',
    modeColon: 'Mode:',
    alreadyJoin: 'This port is already a part of LAG.',
    disabledTip: 'This port cannot be selected. All the member ports in a LAG should have the same settings.',
    tenGdisabledTip: '10 Gbps ports do not support link aggregation.',
    resetNote: 'The VLAN configuration of the selected port will be reset to the default configuration.'
  },
  mactable: {
    describe: 'The MAC address table is used on Ethernet switches to determine where to forward traffic on a LAN.',
    dynamicTime: 'Dynamic MAC address aging time (seconds):',
    vlanId: 'VLAN ID:',
    secRange: '10 - {0}',
    addAddress: 'Add Static MAC Address',
    editAddress: 'Edit Static MAC Address',
    macAddress: 'MAC address:',
    type: 'Type',
    addStatic: 'Add a Static MAC Address',
    search: 'Search',
    deleteTitle: 'Delete Static MAC Address',
    deleteContent: 'Do you want to delete this MAC address?',
    dynamic: 'Dynamic',
    static: 'Static',
    invaild: 'This Mac address cannot be set and the first number cannot be an odd number.',
    portInvalid: 'The selected port does not exist in the VLAN.',
    duplicate: 'You cannot add the same MAC address for a different port under the same VLAN ID configuration.',
    samePortDuplicate: 'The static MAC address is already in use.',
    invalidMacAddress: 'The MAC address cannot consist of only zeros.'
  },
  acl: {
    describe: 'ACL (Access Control List) is an access control tool that filters packets based on packet matching conditions, such as source and destination addresses, and port number of packets. These conditions are created and applied using the L3 (by IP address) and L2 (by MAC address) ACL rules.',
    addMacTitle: 'Add ACL - MAC address',
    addIPTitle: 'Add ACL - IP address',
    editMacTitle: 'Edit ACL - MAC address',
    editIPTitle: 'Edit ACL - IP address',
    permission: 'Permission',
    allow: 'Allow',
    deny: 'Deny',
    source: 'Source',
    destination: 'Destination',
    mask: 'Subnet Mask:',
    port: 'Port',
    any: 'Any',
    direction: 'Direction',
    number: 'ACL No.',
    confirmContent1: 'Source IP address and source subnet mask are required.',
    confirmContent2: 'Destination IP address and destination subnet mask are required.',
    confirmContent3: 'The subnet mask for a single port should be set to "255.255.255.255". If the subnet mask is set to "255.255.255.0", the settings will be applied to the entire subnet.',
    limit: 'MAC ACL number limit: 256',
    deleteTitle: 'Delete ACL Entry',
    deleteContent: 'This action will delete the ACL entry. Are you sure you want to continue?',
    popupNo: 'ACL No.:',
    popupDirection: 'Direction:',
    popupIP: 'IP Address:',
    popupMask: 'Subnet Mask:',
    popupPort: 'Port:',
    defaultTip: 'The word "Any" will be displayed if the field parameter is null or empty.',
    aclRules: 'ACL rules:',
    rulesLimit: 'You have reached the maximum number of ACL rules.'
  },
  rstp: {
    describe: 'Rapid Spanning Tree Protocol (RSTP) prevents network looping and maintains backup ports in case of designated port failure.',
    title: 'RSTP:',
    priority: 'Bridge Priority:',
    role: 'Port Role',
    state: 'State',
    disabled: 'Disabled',
    alternate: 'Alternate',
    backup: 'Backup',
    root: 'Root',
    designated: 'Designated',
    discard: 'Discarding',
    learn: 'Learning',
    forward: 'Forwarding'
  },
  igmp: {
    describe: 'Internet Group Management Protocol (IGMP) snooping monitors IGMP network traffic to control delivery of IP multicasts. This ensures optimal bandwidth utilization. ',
    igmpsnooping: 'IGMP snooping:',
    blockFlooding: 'Multicast flood blocking:',
    igmpsnoopQuerier: 'IGMP querier:',
    blockFloodingNote: 'Block multicast flooding from unknown sources',
    routerPort: 'Router Port',
    fastLeave: 'Fast Leave',
    portSetting: 'Port configuration:',
    statistics: 'Statistics:',
    groupInfo: 'Group Information:',
    querierStatus: 'Querier status',
    querierTrans: 'Querier sent',
    querierReceived: 'Querier received',
    receivedV1: 'Received reports (v1)',
    receivedV2: 'Received reports (v2)',
    receivedV3: 'Received reports (v3)',
    receivedV2Leave: 'Received leave (v2)',
    addressInfo1: 'Define the IPv4 address to use as a source address in the IP header for IGMP Querier election.',
    addressInfo2: 'If the Querier address is not set, the system uses the IPv4 management address of the IP interface associated with this VLAN.',
    addressInfo3: 'If the IPv4 management address is not set, the system uses the first available IPv4 management address.',
    addressInfo4: 'The default is 192.0.2.1.',
    electionInfo1: 'Enables IGMP querier election on the VLAN. Disable to act as an IGMP Non-Querier.',
    electionInfo2: 'This is enabled by default.',
    lagGroupTip: 'LAG ports do not support Fast Leave.',
    supportVlan1: 'Only ports under VLAN1 can be added to the IGMP configuration.'
  },
  qos: {
    describe: 'QoS (Quality of Service) uses traffic prioritization and resource reservation control to provide distinct priorities to different applications, users, and data flow to guarantee a standard level of network performance.',
    dscp: 'DSCP Inspection',
    cos: 'CoS Inspection',
    priority: 'Port Priority',
    queue: 'Priority Queue',
    priorityScope: '(0-7)',
    queueScope: '(1-8)',
    priorityQueue: 'Priority Queue',
    editDscp: 'Edit DSCP Inspection',
    editCos: 'Edit CoS Inspection',
    pcpType: 'CoS value',
    dscpType: 'DSCP value',
    priorityInfo: 'The port priority is first mapped to the Cos value and then mapped to the priority queue based on the CoS queue mapped values.',
    note: 'CoS and DSCP inspection cannot be used when a port is assigned to a LAG. You can only use the priority settings.',
    dscpInfo: 'Specify the priority queue required for DSCP priority queue mapping. 1 has the lowest priority while 8 has the highest priority.',
    cosInfo: 'Specify the priority queue required for CoS priority queue mapping. 1 has the lowest priority while 8 has the highest priority.',
    lagTips: 'You cannot configure QoS on LAG-enabled ports.'
  },
  lldp: {
    describe: 'Link Layer Discovery Protocol (LLDP) collects and monitors network device profiles that are connected to the network switch. The device uses LLDP to learn and distribute device information on network links and provides information about probable faulty network devices.',
    mode: 'LLDP Mode',
    enablelldp: 'LLDP:',
    remoteDevice: 'LLDP Remote Devices',
    remoteDeviceColon: 'LLDP Remote Devices:',
    globalConfig: 'Global LLDP configuration:',
    neighbor: 'Neighbor',
    neighborId: 'Neighbor Port ID',
    chassisId: 'Chassis ID',
    portId: 'Port ID',
    systemName: 'System Name',
    systemCapa: 'System Capabilities',
    managementAddress: 'Management Address'
  },
  mirroring: {
    describe: 'Port mirroring monitors network traffic and forwards a copy of a packet from one network switch port to another.',
    enable: 'Port Mirroring',
    type: 'Mirror type:',
    config: 'Configuration',
    transReceive: 'Transmit & receive',
    transOnly: 'Transmit only',
    receiveOnly: 'Receive only',
    port: 'Mirrored ports',
    source: 'Source port: ',
    destination: 'Destination port: ',
    sourceNoColon: 'Source port',
    destinationNoColon: 'Destination port',
    warningMsg: 'Source port is required. Please select a source port.'
  },
  systemInfo: {
    devicename: 'Switch Name:',
    macaddress: 'MAC address:',
    version: 'Firmware Version:',
    dhcp: 'DHCP',
    active: 'Active',
    inactive: 'Inactive',
    standby: 'Standby',
    on: 'On',
    off: 'Off',
    factoryReset: 'Factory Reset',
    factoryResetAlert: 'Do you want to reset to default settings?'
  },
  systemDhcp: {
    oobPort: 'Out-of-Band Management',
    vlanPort: 'Inband Management',
    managementMode: 'Management access:',
    managementModeInfo: 'When using OOB management, you can access QSS using only the maintenance port.',
    managementModalContent: 'Changing the management access will disconnect your device from the switch. To access QSS, you must connect your device to the inband or OOB port using an Ethernet cable. Do you want to continue?',
    optionInBandMode: 'In-band',
    optionOutBandMode: 'Out-of-Band (OOB)',
    radioIp: 'Manually set the IP & DNS',
    radiodhcp: 'Automatically obtain IP & DNS',
    ip: 'IP Address:',
    subnet: 'Subnet:',
    getway: 'Gateway:',
    dns: 'DNS:',
    ipwarning: 'The IP address is required.',
    subnetwarning: 'The subnet mask is required.',
    dhcpalert: 'Your IP address will be changed by the DHCP service. Do you want to continue?',
    staticalert: 'Your IP address will be changed to {0}. Do you want to continue?',
    qfinderTitle: 'Click here to download Qfinder Pro',
    qfinderContent: 'If this page does not load, you can use Qfinder Pro to access the QSS login page.',
    inBandContent: 'Your device will disconnect from the switch after you change the management mode settings. To access QSS, you must connect your device to the inband port using an Ethernet cable. Do you want to continue?',
    outBandContent: 'Your device will disconnect from the switch after you change the management mode settings. The OOB interface only supports web management services. Services such as SNMP and NTP are not supported when using the OOB interface. To access QSS, you must connect your device to the OOB port using an Ethernet cable. Do you want to continue?'
  },
  systemPwd: {
    newPwd: 'New password:',
    confirmPwd: 'Confirm new password:',
    change: 'Change Password',
    changeFail: 'Unable to change password.',
    notMatch: 'The passwords do not match.',
    currentPwd: 'Current password:',
    invalid: 'Invalid password.'
  },
  systemTime: {
    currentDandT: 'Current date & time:',
    timeZone: 'Time zone:',
    format: 'Date & time format:',
    setting: 'Time configuration:',
    dateTime: 'Date/ Time:',
    server: 'Server:',
    radiodevice: 'Synchronize with device',
    radiomanual: 'Manual configuration',
    radiosync: 'Synchronize with internet time server',
    unknown: 'unknown',
    bytime: 'Set by time zone',
    bycountry: 'Set by country',
    gmt: 'GMT',
    dst: 'Daylight saving time:',
    dstDisable: 'disable',
    dstAuto: 'Adjust the system clock automatically',
    dstOffset: 'Offset:',
    dstManual: 'Adjust the system clock manually',
    dstManualWarning: 'The DST range cannot be less than the specified offset value.',
    recentDst: 'Most recent daylight saving time:',
    dstStart: 'Start time:',
    dstEnd: 'End time:',
    dstWeek: 'Week:',
    dstDay: 'Day:',
    dstMonth: 'Month:',
    dstHours: 'Hours:',
    dstMinutes: 'Minutes:',
    dstOffsetMinutes: 'minutes'
  },
  systemBackup: {
    backupBtn: 'Backup',
    backupTitle: 'Back up System Settings',
    backupContent: 'To backup all settings (including user accounts, server name and network configuration) click "Backup" and select to open or save the settings file.',
    restoreBtn: 'Restore',
    restoreTitle: 'Restore System Settings',
    restoreContent: 'To restore all settings: click "Browse", select a previously-saved settings file, and click "Restore".',
    restoreError: 'The configuration file cannot be modified.',
    restoreMsg: 'The system will automatically restart after the configuration file is loaded. Do you want to continue?',
    passwordReset: 'Password Reset',
    passwordResetContent: 'You can reset the password by clicking "Password Reset", or by pressing and holding the physical reset button for 5 seconds.',
    passwordResetAlert: 'Are you sure you want to reset the password? Click "Yes" to change the password. ',
    factoryResetContent: 'Reset the entire configuration back to default by clicking "Factory Reset", or by pressing and holding the physical reset button for 10 seconds.'
  },
  systemHttps: {
    checkboxHttpsEnable: 'Enable secure connection (HTTPS)',
    checkboxHttpsOnlyEnable: 'Force secure connection (HTTPS) only',
    tlsVersion: 'TLS version compatibility:',
    tlsVersionLabel11: '1.1 and later',
    tlsVersionLabel12: '1.2',
    portNumber: 'Port number:',
    tlsVersionInfo: 'Use the latest TLS version to increase system security. Clients could, however, encounter compatibility issues with the updated TLS versions.',
    httpsOnlyInfo: 'You can access the web administration page only via HTTPS after enabling "Force secure connection (HTTPS) only".'
  },
  systemSnmp: {
    checkboxSnmpServiceEnable: 'Enable SNMP service',
    snmpVersion: 'SNMP version:',
    snmpVersionLabel1: 'SNMPv1',
    snmpVersionLabel2: 'SNMPv2c',
    snmpVersionLabel3: 'SNMPv3',
    snmpCommunity: 'Community string:',
    snmpUserName: 'Username:',
    checkboxSnmpAuthEnable: 'Authentication',
    snmpAuthProtocol: 'Authentication protocol:',
    snmpAuthProtocolLabel1: 'HMAC-MD5',
    snmpAuthProtocolLabel2: 'HMAC-SHA',
    snmpAuthPassword: 'Authentication password:',
    checkboxSnmpPrivacyEnable: 'Privacy',
    snmpPrivacyProtocol: 'Privacy protocol:',
    snmpPrivacyProtocolLabel1: 'CBC-DES',
    snmpPrivacyPassword: 'Privacy password:',
    snmpTrapLevel: 'SNMP trap:',
    snmpTrapColdStart: 'coldStart',
    snmpTrapWarmStart: 'warmStart',
    snmpTrapLinkUp: 'linkUp',
    snmpTrapLinkDown: 'linkDown',
    snmpTrapAddress: 'Trap address {0}:',
    snmpMib: 'SNMP MIB',
    snmpMibInfo: 'To install the MIB to your managing system, click [Download].',
    snmpMibDownload: 'Download',
    snmpAuthPassLen: 'Authentication password length: 8-31 characters',
    snmpPrivacyPassLen: 'Privacy password length: 8-31 characters',
    snmpCommunityStrLen: 'Community string length: 1-31 characters',
    snmpUserNameLen: 'Username length: 1-31 characters'
  },
  remoteDevice: {
    other: 'Other',
    repeater: 'Repeater',
    bridge: 'Bridge',
    WLAN: 'WLAN Access Point',
    router: 'Router',
    telephone: 'Telephone',
    cable: 'DOCSIS cable device',
    station: 'Station Only',
    reserved: 'Reserved'
  },
  timestamp: {
    day: 'day(s)',
    hour: 'hour(s)',
    min: 'min(s)',
    sec: 'sec(s)'
  },
  updatefw: {
    fwVersion: 'Current firmware version:',
    date: 'Date:',
    systemuptime: 'System up time:',
    status: 'Status:',
    checkupdate: 'Check for update',
    selectfile: 'Select a file',
    browse: 'Browse',
    updatesystem: 'Update System',
    updateContent: 'A new firmware version/patch is available. Version: {version}',
    build: 'Build',
    updateFail: 'Failed to update firmware.',
    downloadFail: 'Failed to download firmware.',
    alreadyUpdate: 'Your system is up-to-date.',
    localUpdateContent: 'Are you sure you want to update and restart the system? Click "Update" to start the update process, or "Cancel" to stay on the current page.',
    fwFailContent: 'System error. Unable to update the firmware. (Error code: {error_code})',
    digiSignTitle: 'Invalid Digital Signature',
    digiSignNotValid: 'The firmware does not contain a valid digital signature.',
    digiSignExp: 'The digital signature of the firmware is expired. The firmware integrity could be compromised. Do you want to continue updating the firmware?\nThe system will restart when the update is complete.',
    unAuthChange: 'The system found unauthorized changes on the firmware.',
    fwFailTitle: 'Firmware Update Failure',
    autoFwTitle: 'New Firmware Available',
    autoFwContent1: 'A new firmware version for the device is now available. The firmware includes an updated digital signature to ensure switch safety. QNAP recommends updating the firmware to the latest version to avoid potential security breaches.',
    autoFwContent2: 'Click "Update" to update the firmware now. You can also update the firmware by going to the System Management page.',
    autoFwContent3: 'Note:',
    autoFwContent4: 'The network connection is interrupted during the firmware update process. The switch will reboot once the process is complete to apply the updates.'
  },
  helper: {
    step: 'Step {0}',
    portSettingContent1: 'State: Enable/disable each switching port by turning on or off the port state. The state is enabled by default.',
    portSettingContent2: 'Speed*: Configure the maximum speed by choosing the speed from the drop-down menu. Speed is set to "Auto" by default.',
    portSettingContent3: 'Flow Control: Enable/disable the flow control by turning it on or off. It is disabled by default.',
    // portSettingContent4: 'Click "Apply" to apply and save the configuration.',
    portSettingContent5: '*Note: QSW supports Auto MDI/MDI-X and IEE 802.3x flow control which ensures balance of speed and traffic between transmission and reception. We suggest setting "Speed" and "Flow Control" to Default, to establish smooth working of link speed auto-negotiate and flow control.',
    portSettingContent6: 'Note: The device supports Auto MDI/MDI-X, IEEE 802.3ap-2007, and IEEE 802.3x flow control standards. This ensures speed and traffic balance during data transfer. QNAP recommends setting "Maximum Speed", "FEC", and "Flow Control" to default mode to ensure optimal performance of link speed, data reliability, and Ethernet flow control.',
    portSettingContent7: 'FEC: Enable Forward Error Correction (FEC) to enhance data reliability by introducing redundant data prior to data transmission. The function is disabled by default.',
    vlanSettingContent1: 'Click "Add" to initiate a new VLAN configuration.',
    vlanSettingContent2: 'VLAN ID: A valid ID must be between 2-4000. The ID number cannot be repeated.',
    vlanSettingContent3: 'Port: Choose the port member(s) for the VLAN.',
    vlanSettingContent4: 'Tagged and Untagged: Check the tagged or untagged port members if needed.',
    vlanSettingContent5: 'Click "Save" to apply and save the configuration.',
    vlanSettingContent6: 'Action: Click "{edit}" to edit the configuration or "{trashcan}" to delete it.',
    vlanSettingContent7: 'Note: If you chose to add a LAG to VLAN, ensure that all bonded ports of the LAG are added.',
    lagSettingContent1: 'Click "Edit Group" to initiate a LAG configuration.',
    lagSettingContent2: 'Group Number: A valid number must be between 1-{0}. Group number cannot be repeated.',
    lagSettingContent3: 'Mode: Choose between "LACP" and "Static" mode.',
    lagSettingContent4: 'LACP: A protocol that allows the port to participate only in dynamic aggregation selection. The port is part of the best aggregation selected by the system. LACP places the port into a passive negotiating state, in which the port waits for its peers to initiate negotiation.',
    lagSettingContent5: 'Static: A protocol that allows the port to participate in static aggregation, wherein the port channel should be manually assigned to its member ports. Static LAG enables channeling without waiting for port peers to initiate negotiation.',
    lagSettingContent6: 'Selected: Choose the port members for the group.',
    lagSettingContent7: 'Click "Save" to apply and save the configuration.',
    lagSettingContent8: 'Action: Click "{edit}" to edit the configuration or "{trashcan}" to delete the it.',
    lagSettingContent9: 'Note: If you want to enable LAGs on a VLAN, ensure that member ports of the LAG are removed from the VLAN and add the entire LAG to the VLAN as required.',
    rstpSettingContent1: 'Confirm if all physical links of the LAN are established properly.',
    rstpSettingContent2: 'RSTP: Enable RSTP. It is disabled by default.',
    rstpSettingContent3: 'Bridge Priority: A value that decides which switch can be be the root switch. The default RSTP priority is "32768".',
    rstpSettingContent4: 'Action: Enable/disable the RSTP of each switching port. When enabled, RSTP is enabled on all ports by default. You can disable them individually if required.',
    // rstpSettingContent5: 'Click "Apply" to apply and save the configuration.',
    lldpSettingContent1: 'LLDP: Enable/disable LLDP. It is enabled by default.',
    lldpSettingContent2: 'LLDP Remote Devices: Check the profiles of remote devices currently connected.',
    lldpSettingContent4: 'MAC Address Table: View this tab to check the history of MAC addresses of all connected devices.',
    igmpSettingContent1: 'IGMP snooping: Enable/disable IGMP snooping. The state is disabled by default.',
    igmpSettingContent2: 'Multicast flood blocking*: Enable if necessary. It is disabled by default.',
    igmpSettingContent3: 'Router Port: Assign a router port to the necessary port or LAG configuration. Fast-leave cannot be enabled if a port is assigned to this function.',
    igmpSettingContent4: 'Fast-Leave: Enable fast-leave for all necessary ports.',
    // igmpSettingContent5: 'Click "Apply" to apply and save the configuration.',
    igmpSettingContent6: 'Note: Multicast flood blocking will block all multicast packets, including system control packets. We suggest that this function remains disabled unless necessary.',
    aclSettingContent1: 'Choose either ACL by IP Address or ACL by MAC Address.',
    aclSettingContent2: 'Click "Add" to initiate a new ACL configuration.',
    aclSettingContent3: 'Steps to configure "Add ACL - IP Address"',
    aclSettingContent4: 'Set the ACL No. between 1 - 255 (cannot be repeated). The ACL rules are executed based on priority of the ACL number sequence. The smallest number gets the highest priority.',
    aclSettingContent5: 'Enter the source IP address and source subnet mask.',
    aclSettingContent6: 'Set the destination IP address and destination subnet mask.',
    aclSettingContent7: 'Select the port(s) to which permissions should apply.',
    aclSettingContent8: 'Permission: Choose between Allow and Deny',
    aclSettingContent9: 'Click "Save" to apply and save the configuration.',
    aclSettingContent10: 'Steps to configure "Add ACL - MAC Address"',
    aclSettingContent11: 'Set the ACL No. between 1 - 255 (cannot be repeated). The ACL rules are executed based on priority of the ACL number sequence. The smallest number gets the highest priority.',
    aclSettingContent12: 'Set the source MAC address.',
    aclSettingContent13: 'Set the destination MAC address.',
    aclSettingContent14: 'View the created ACLs on the ACL tables. Click "{edit}" to edit the configuration or "{trashcan}" to delete it.',
    aclSettingContent15: 'Note: MAC address-based ACL rules have higher priority than IP address-based ACL rules. When the switch determines that an ACL rule applies to a packet, it checks whether the packet conditions meet the MAC address-based ACL rule first. If the conditions don\'t match the rule, the switch checks the packet conditions against the IP address-based ACL rule. If the conditions are denied, the packet is blocked. Otherwise, the packet is permitted.',
    qosSettingContent1: 'DSCP Inspection: Enable/disable to check the Differentiated Services Code Point bits in the IPV4 L3 IP header to determine the priority of each frame.',
    qosSettingContent2: 'Advanced setting: By clicking "Edit DSCP Inspection" you can map the DSCP value (0-63) to priority (1 lowest - 8 highest) manually, however we suggest keeping the default setting for general applications.',
    qosSettingContent3: 'CoS Inspection: Enable this setting to check the 802.1p Class of Service (CoS) bits in the L2 VLAN tag to determine the priority of each frame.',
    qosSettingContent4: 'Advanced settings: By clicking "Edit CoS Inspection" you can map different CoS values (0-7) to different egress queues (1 has the lowest priority and 8 has the highest priority) manually, however, we suggest keeping the default setting for general applications.',
    qosSettingContent5: 'Priority: Set port priority by clicking "+" or "-". 0 has the lowest priority and 7 has the highest priority.',
    // qosSettingContent6: 'Click "Apply" to apply and save the configuration.',
    qosSettingContent7: 'Note: Weighted Round Robin (WRR) is applied as the default QoS scheduling mechanism - the number of packets sent from the queue are proportional to the weight of the queue. WRR scheduling prevents packets in low-priority queues from not being served, and ensures that delay-sensitive packets are preferentially transmitted.',
    qosSettingContent8: 'Note: Priority of an ingress frame is determined by the order of \n1. DSCP,\n2. CoS, and\n3. Priority. You can manually enable these options as a combination or individually. For instance, if a "top-priority" port is required for a network design, ToS/DSCP inspection and CoS inspection can be disabled. This setting leaves only the port priority setting active, which results in all ingress frames being assigned the same priority on that port. ',
    qosSettingContent9: 'DSCP values and priority queues or CoS priority values mapping',
    qosSettingContent10: 'DSCP {0}: priority {1}',
    qosSettingContent11: 'CoS priority values or priority queues and IEEE 802.1D traffic types mapping',
    qosSettingContent12: 'CoS {0}:',
    qosSettingContent13: 'Best Effort (default)',
    qosSettingContent14: 'Background',
    qosSettingContent15: 'Standard (spare)',
    qosSettingContent16: 'Excellent Effort (business critical)',
    qosSettingContent17: 'Controlled Load (streaming multimedia)',
    qosSettingContent18: 'Video (interactive media); fewer than 100 milliseconds of latency and jitter',
    qosSettingContent19: 'Voice (interactive voice); fewer than 10 milliseconds of latency and jitter',
    qosSettingContent20: 'Network Control Reserved traffic',
    qosSettingContent21: 'Port Priority: Set port priority by clicking "+" or "-". 0 has the lowest priority and 7 has the highest priority.',
    // qosSettingContent22: 'Click "Apply" to apply and save the configuration.',
    qosSettingContent23: 'Note: Priority of an ingress frame is determined by the order of \n1. DSCP,\n2. CoS, and\n3. Priority. You can manually enable these options as a combination or individually. For isntance, if a "top-priority" port is required for a network design, ToS/DSCP inspection and QoS inspection can be disabled. This setting leaves only the port priority setting active, which results in all ingress frames being assigned the same priority on that port.',
    poeSettingContent1: 'Power over Ethernet (PoE) allows the switch to supply power to connected devices through the same Ethernet LAN cable that transmits data.',
    poeSettingContent2: 'PoE mode: Select the PoE mode from the drop-down menu.',
    poeSettingContent3: 'Priority: To correct PoE oversubscription, set port priority for provisioning power resources to devices connected to switch ports having higher priority. A lower-numbered port has priority over a higher-numbered port within the same configured priority class. For example, the system prioritized port 3 over port 7 if both ports are configured with low priority.',
    poeSettingContent4: 'Click "Save" to save and apply changes.',
    poeSettingContent5: 'The PoE schedule feature allows you to enable the PoE function on selected ports on recurring days and time.',
    poeSettingContent6: 'PoE schedule is disabled for all ports by default. You can enable the PoE schedule for each port as needed.',
    poeSettingContent7: 'Click the edit icon to enable PoE at a specified day and time for each port.',
    poeSettingContent8: 'Select one or multiple ports to apply the configured PoE schedule.',
    poeSettingContent9: 'Specify the PoE operating hours for the ports.',
    poeSettingContent10: 'Click "Activate schedule now".',
    poeSettingContent11: 'Click "Save" to save and apply changes.',
    poeSettingContent12: 'PoE legacy mode: Enable to provide power to connected PDs that do not fully comply with the IEEE 802.3af/at/bt standard.',
    loopProtectionContent1: 'Enable or disable loop protection. Loop protection is disabled by default.',
    loopProtectionContent2: 'Specify the shutdown time between 0 and 604800 seconds to control how long the port is blocked once a network loop is detected.',
    loopProtectionContent3: 'Note: Specifying the value as 0 enables loop protection on the interface indefinitely.',
    loopProtectionContent4: 'Select one or more ports on which to enable loop protection. The switch blocks the port traffic when a network loop is detected.',
    loopProtectionContent5: 'Note: Using the reset function deletes all loop protection information and allows traffic on all switch ports.'
  },
  loopProtection: {
    loopProtection: 'Loop Protection',
    describe: 'A network loop occurs when broadcast packets are forwarded continuously between two network devices. If a loop is detected, loop detection automatically disables the interface.',
    title: 'Loop protection:',
    transmissionTime: 'Transmission time:',
    shutdownTime: 'Shutdown time:',
    transmissionTimeValid: 'The value must be between 1 - 10.',
    shutdownTimeValid: 'The value must be between 0 - 604800.',
    timeDefault: 'The default is {value}.',
    transmissionTips: 'Transmission time controls how long to wait between sending loop protection packets.\n{last}',
    shutdownTimeTips: 'Shutdown time controls how long to disable a port after detecting a loop.\n{last}',
    loopProtectionStauts: 'Loop protection status:',
    reset: 'Reset',
    port: 'Port',
    loops: 'Loops',
    looping: 'Looping',
    lastLoop: 'Last Loop',
    seconds: 'Seconds',
    true: 'True',
    false: 'False',
    conflict: 'You cannot enable loop protection and RSTP simultaneously.',
    shutdownTimeInfo: 'Specify the shutdown time between {0} and {1} seconds to control how long the port is blocked once a network loop is detected.\nNote: Specifying the value as 0 enables loop protection on the interface indefinitely.'
  },
  poe: {
    currentTitle: 'Current Power Consumption (Port {0}):',
    totalPower: 'Current Power Consumption (Total):',
    maxminPower: 'Min/Max Consumption:',
    choosePort: 'Port:',
    port: 'Port {0}',
    total: 'All ports',
    watt: '(W)',
    tooltips: 'Power consumption: {0} W',
    configTitle: 'Global PoE power configuration:',
    mode: 'PoE Mode',
    priority: 'Priority',
    requirement: 'PD Requirement',
    maxPower: 'Allocated Power',
    powerSup: 'Maximum PoE supply (watts):',
    reservePower: 'Reserved power rule:',
    powerMgtMode: 'Power Management Mode',
    class: 'PoE Class',
    allocation: 'Custom',
    actualMode: 'Actual Consumption',
    reserveMode: 'Reserved',
    consumptionMode: 'Consumption',
    high: 'High',
    low: 'Low',
    critical: 'Critical',
    disableMode: 'Disabled',
    poeMode: 'PoE',
    plusMode: 'PoE+',
    uPoeMode: 'UPoE',
    dPlusMode: 'PoE++',
    manageModeInfoTitle1: 'Actual Consumption:',
    manageModeInfoTitle2: 'Fixed Power Budget:',
    manageModeInfo1: 'Ports are shut down if the actual power consumption for all ports exceeds the capacity of the power supply, or if a given port exceeds the reserved power for that port. Ports are shut down according to their port priority; if multiple ports share the same priority, the port with the highest number is shut down.',
    manageModeInfo2: 'Ports are shut down when the total reserved powered exceeds the capacity of the power supply. Port power is not turned on if a PD requests more power than the power supply can provide.',
    ruleInfoTitle1: 'PoE Class of PD: Reserves power based on the PoE class for a powered device',
    ruleInfoTitle2: 'Custom: Reserves a specified amount of power for each port',
    ruleInfo1: 'This is the default value.',
    ruleInfo2: 'If allocation is defined, the maximum power for all ports should be defined.',
    ruleInfoTitle3: 'Consumption mode: Power is not reserved based on the PoE class of a powered device.',
    ruleInfoTitle4: 'Reserved mode: Power is reserved based on the PoE class of a powered device.',
    ruleInfo3: 'In Reserved mode, the switch reserves power automatically after the PoE class of the powered device is identified. Power is not reserved based on the actual amount of power being consumed by the device.',
    poeModeInfo1: 'PoE Mode controls the PoE operating mode for the port .',
    poeModeInfo2: ' Port {0} - {1}: {2}',
    poeModeInfo3: 'Port 5 - 16: PoE+ (802.3at)',
    poeModeInfo4: 'PoE: The port uses PoE IEEE 802.3af (limited to 15.4W).',
    poeModeInfo5: 'PoE+: The port uses PoE+ IEEE 802.3at (limited to 30W).',
    poeModeInfo6: 'UPoE: The port uses UPOE (limited to 60W)',
    priorityInfo1: 'Controls the priority of each port. If multiple ports share the same priority, the port with the lower number is given priority.',
    priorityInfo2: 'Set to low by default.',
    requireInfo: 'The maximum power required by the PD.',
    powerInfo: 'Specifies a maximum amount of power available to the port.',
    pdclass: 'PD class',
    powerUse: 'Power Consumption',
    schedule: 'Schedule:',
    turnOn: 'Activate schedule now',
    title: 'PoE Schedule Configuration',
    poeModeInfo7: 'PoE++: The port uses PoE+ IEEE 802.3bt (limited to 90W)',
    boundingNote: 'Note: The switch cannot provision power to the connected powered device if the available power resource is less than the power class of the device.',
    simpleWatt: 'Watts',
    notSup: 'PoE is not supported.',
    applyTo: 'Apply to:',
    legacyMode: 'PoE Legacy Mode',
    legacyTip: 'When enabled, the device checks the PoE compatibility of the connected PDs and provides power to devices that do not fully comply with the IEEE 802.3af/at/bt standard'
  },
  weekday: {
    sun: 'Sunday',
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday'
  },
  dstWeek: {
    sun: 'Sunday',
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
    sat: 'Saturday'
  },
  dstDay: {
    First: 'First',
    Second: 'Second',
    Third: 'Third',
    Fourth: 'Fourth',
    Last: 'Last'
  },
  dstMonth: {
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'June',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December'
  }
}



// WEBPACK FOOTER //
// ./src/locales/ENG.js